import { createTheme } from '@mui/material'
import colors from './colors'

export const MenuDarkTheme = createTheme({
  components: {
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff', // Clean white background
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          padding: '8px',
          minWidth: '200px',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#374151', // Dark gray text
          fontSize: '14px',
          fontWeight: 500,
          borderRadius: '8px',
          padding: '10px 12px',
          margin: '2px 0',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            backgroundColor: '#f3f4f6', // Light gray hover
            color: '#8b5cf6', // Purple text on hover
            transform: 'translateX(2px)',
          },
          '&:active': {
            backgroundColor: '#8b5cf6', // Purple background on click
            color: '#ffffff', // White text on click
          },
          // Special styling for destructive actions (Delete)
          '&[data-action="delete"]': {
            color: '#dc2626', // Red text for delete
            '&:hover': {
              backgroundColor: '#fef2f2', // Light red hover
              color: '#dc2626',
            },
            '&:active': {
              backgroundColor: '#dc2626',
              color: '#ffffff',
            },
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: '0',
        },
      },
    },
  },
})
